import React, { useContext, useEffect, useState } from "react";
import { SelectCard, BackButton } from './../../components/index'
import { ReleaseTrackerDataService, softwareNameToId, softwareNameToImg} from "../../data/ReleaseTrackerDataService";
import { AuthContext } from "../../auth/AuthHandler";

export default function Software() {

  const [softwares, setSoftwares] = useState([]);

  const authCtx = useContext(AuthContext)
  useEffect(() => {
    const relTrackerService = new ReleaseTrackerDataService(authCtx);
    relTrackerService.getSoftwares()
      .then(data => {
        setSoftwares(data);
      })
      .catch(err => {
        console.error(err);
      })
    }, [authCtx]);
    // pass a second empty array to tell react that the effect isn’t dependent on any values from props
    // and prevent an infinite loop error.

  return (
    <div className="software">
      <BackButton />
      <h2>Select an Option</h2>
      <div className="cards">
        {softwares.map((software, index) => (
          <SelectCard 
            key={software.Name}
            img={softwareNameToImg(software.Name)}
            title={software.Name}
            url={{pathname: "/software/"+softwareNameToId(software.Name)}}
            />
        ))}
      </div>
    </div>
    
  )
}
